module.exports = __webpack_public_path__ + "media/images/front/societies/society_jsa-b43a1b41ab7a8d117408dc0b537e3a82.jpg";